var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pure-g",attrs:{"id":"main-wrap"}},[_c('div',{staticClass:"pure-u-3-5",attrs:{"id":"main-col"}},_vm._l((_vm.grapes),function(grape){return _c('Grape',{key:grape.id,attrs:{"grapeInstance":grape,"single":true}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ec49a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewGrape.vue
// module id = null
// module chunks = 